{
  "recommendationAccepted": false,
  "numberOfDocumentsRequested": 0,
  "setCompletionDateForEmail": "",
  "opportunityOwnerTextForEmail": "Mojo Mortgages Dev Mode",
  "ownerEmailAddress": "devmode@mojomortgages.com"
}